import axios from 'axios'

const state = {}

const mutations = {}

const actions = {
  async next({}, type) {
    const httpResult = await axios.get('/api/sequence/next/' + type)
    return httpResult.data.nextItem
  },
}

const getters = {}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
